<template>
  <div>
    <b-button
      :id="popoverId"
      :class="`mt-0 d-flex align-items-center badge px-2`"
      :variant="variant"
      :size="buttonSize"
      pill
    >
      <slot />
    </b-button>

    <b-popover :target="popoverId ? popoverId : 'popover'" triggers="hover" placement="top">
      <template v-slot:title>{{ popupTitle }}</template>
      <div class="pt-2 content">
        {{ popupContent }}
      </div>
      <div class="d-flex justify-content-end">
        <b-link
          :to="popupHref"
          class="text-secondary link"
          :target="targetBlank ? '_blank' : '_self'"
        >
          {{ popupButton }}
        </b-link>
      </div>
    </b-popover>
  </div>
</template>

<script>
export default {
  name: "PrivacyAlert",
  props: {
    variant: {
      type: String,
      default: "info",
    },
    popoverId: String,
    popupTitle: String,
    popupContent: String,
    popupButton: String,
    popupHref: Object | String,
    buttonSize: String,
    targetBlank: Boolean,
    pill: Boolean,
  },
};
</script>

<style scoped lang="scss">
.link {
  font-size: 0.85rem;
  text-decoration: none;
}
svg {
  margin-right: 0.25rem;
}
.badge {
  line-height: 1.5;
  padding: 0.3rem 1rem !important;
  border: none;
  &.btn-info {
    background: $color-light !important;
    color: $color-blue !important;
  }
  &.btn-warning {
    background: rgba($color-yellow, 0.2) !important;
    color: $color-yellow !important;
  }
  &.btn-info:not(:disabled):not(.disabled):active:focus {
    box-shadow: none;
  }
}
::v-deep .popover-header {
  padding-top: 0.75rem;
  color: $color-dark;
}
</style>
